<script setup lang="ts">
import { isNothing, toMaybe } from "../../lib/maybe";
import { useTemplateRef, watchEffect } from "vue";

/** Renders trusted, app-bundled SVG markup (not user content). */
const props = defineProps<{
  markup: string;
}>();

const host = useTemplateRef<HTMLElement>("host");

watchEffect(() => {
  const el = toMaybe(host.value);
  if (isNothing(el)) return;
  el.value.innerHTML = props.markup;
});
</script>

<template>
  <span ref="host" />
</template>
